<template>
  <ShortcutPage :release="release"></ShortcutPage>
</template>
<script>
import ShortcutPage from './ShortcutPage'

export default {
  name: 'Baluchon',
  data: function() {
    return { release: null }
  },
  components: {
    ShortcutPage,
  },
  mounted: function () {
    this.release = {
      img: '/img/game-murmures.jpg',
      name: 'Murmures des marais (Original Soundtrack)',
      type: 'album',
      links: [
        {
          service: 'bandcamp',
          url: 'https://grizzlygames.bandcamp.com/album/murmures-des-marais',
          btnLabel: 'Listen'
        },
        {
          service: 'spotify',
          url: 'https://open.spotify.com/intl-fr/album/7tGjeVjn2sDGJy1vedHQ5j',
          btnLabel: 'Listen'
        },
        {
          service: 'youtube',
          url: 'https://www.youtube.com/watch?v=gNK9JSkC50A&list=OLAK5uy_muTV9eF8UJa0aQWWLQcSY6U1SZrrLAr_I',
          btnLabel: 'Listen'
        },
        {
          service: 'deezer',
          url: 'https://www.deezer.com/fr/album/769756081',
          btnLabel: 'Listen'
        },
        {
          service: 'apple',
          url: 'https://music.apple.com/us/album/murmures-des-marais/1819670274?l=fr-FR',
          btnLabel: 'Listen'
        },
        {
          service: 'itunes',
          url: 'https://music.apple.com/us/album/murmures-des-marais/1819670274?l=fr-FR',
          btnLabel: 'Buy'
        },
        {
          service: 'amazon',
          url: 'https://amazon.fr/music/player/albums/B0FCG7N4F8?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_zUwYUmuKcRvoyH5yevFLbyVCp',
          btnLabel: 'Buy'
        },
        {
          service: 'tidal',
          url: 'https://tidal.com/browse/album/441022544',
          btnLabel: 'Listen'
        }
      ]
    }
  }
}
</script>